// Staff roles. Office assistants work in the admin area but have no Community section (helpdesk, announcements);
// operators have no Finance section (billing, transactions).
export const STAFF_ROLES = ['ADMIN', 'MASTER_ADMIN', 'OFFICE_ASSISTANT', 'OPERATOR'];
export const COMMUNITY_ROLES = ['ADMIN', 'MASTER_ADMIN', 'OPERATOR'];
export const FINANCE_ROLES = ['ADMIN', 'MASTER_ADMIN', 'OFFICE_ASSISTANT'];
// Who can post, edit and remove notices (the server enforces the same list)
export const NOTICE_ROLES = ['MASTER_ADMIN', 'OPERATOR'];

export const ROLE_NAMES = {
    MASTER_ADMIN: 'Master admin',
    ADMIN: 'Admin',
    OFFICE_ASSISTANT: 'Office assistant',
    OPERATOR: 'Operator',
    RESIDENT: 'Resident',
};

export const isStaff = (role) => STAFF_ROLES.includes(role);
export const canAccessCommunity = (role) => COMMUNITY_ROLES.includes(role);
export const canAccessFinance = (role) => FINANCE_ROLES.includes(role);
export const canPostNotices = (role) => NOTICE_ROLES.includes(role);
export const homeFor = (role) => (isStaff(role) ? '/admin/dashboard' : '/resident/dashboard');
